import { IntegrationType } from '@principle-theorem/integrations';
import {
  CommunicationDirection,
  IAutomatedNotification,
  IAutomation,
  IPatient,
  IPractice,
  SMSConversation,
  SMSDeliveryStatus,
  SMSMessage,
} from '@principle-theorem/principle-core/interfaces';
import { BaseFirestoreMock, Properties } from '@principle-theorem/shared';
import { MockDocRef } from '@principle-theorem/testing';

export class SMSMessageMock
  extends BaseFirestoreMock<Properties<SMSMessage>>
  implements Properties<SMSMessage>
{
  readBy = [];
  body = 'Test Subject';
  patientPhoneNumber = '+61234567890';
  patientRef = MockDocRef<IPatient>();
  practicePhoneNumber = '+61234567891';
  practiceRef = MockDocRef<IPractice>();
  conversationRef = MockDocRef<SMSConversation>();
  authorRef: IntegrationType.Twilio = IntegrationType.Twilio;
  direction = CommunicationDirection.Outbound;
  status = SMSDeliveryStatus.Pending;
  automationRef = MockDocRef<IAutomation<IAutomatedNotification>>();
}
